module.exports = __webpack_public_path__ + "img/test-profile-img.68032497.svg";